import React from 'react';
import { QueueStat } from '../queue-stat/QueueStat';
import { StartCodingButton } from '../start-coding-button/start-coding-button';
import './queue-row.scss';

export interface QueueRowProps {
  queueName: string;
  totalInQueue: number;
  criticalAge: number;
  onStartCoding: () => void;
  startCodingDisabled?: boolean;
  className?: string;
}

export const QueueRow: React.FC<QueueRowProps> = ({
  queueName,
  totalInQueue,
  criticalAge,
  onStartCoding,
  startCodingDisabled = false,
  className = ''
}) => {
  return (
    <div className={`cmx-queue-row ${className}`.trim()} data-testid="queue-row">
      <span
        className="cmx-queue-row__name"
        title={queueName}
        data-testid="queue-row-name">
        {queueName}
      </span>
      <div className="cmx-queue-row__stats">
        <QueueStat
          label="Total in Queue"
          value={totalInQueue}
          className="cmx-queue-row__stat"
        />
        <QueueStat
          label="Critical Age"
          value={criticalAge}
          colorOverride="var(--coder-view-critical-age-color)"
          className="cmx-queue-row__stat"
        />
      </div>
      <div className="cmx-queue-row__action">
        <StartCodingButton
          onClick={onStartCoding}
          disabled={startCodingDisabled}
        />
      </div>
    </div>
  );
};

QueueRow.displayName = 'QueueRow';
